const AnalyticsProvider = {
	GOOGLE: "google",
	INTERNAL: "internal",
	ALL: "all"
};
export default AnalyticsProvider;
